const normalizeTagName = (value) =>
  String(value || "")
    .trim()
    .toLocaleLowerCase("es-MX");

export function sortTagsForDisplay(tags = []) {
  return [...tags].sort((a, b) =>
    normalizeTagName(a?.nombre ?? a?.label).localeCompare(
      normalizeTagName(b?.nombre ?? b?.label),
      "es-MX"
    )
  );
}
